import { useState } from 'react';
import { AxiosPublic } from '../utils/axios';

export const useGetOrganizations = () => {
  const [isFetching, setFetching] = useState(false);
  const [organizationItems, setOrganizationItems] = useState<
    {
      value: string;
      label: string;
      orgType: string;
      disableAddressTo: boolean;
    }[]
  >([]);

  return {
    isFetching,
    organizationItems,
    onLoad: async (autoComplete?: boolean) => {
      try {
        setFetching(true);
        const { data } = await AxiosPublic.get('/organizations?orderBy=name&order=ASC');

        setOrganizationItems(
          data.map(item =>
            autoComplete
              ? { value: item.id, name: item.name, orgType: item.orgType, disableAddressTo: item.disableAddressTo }
              : {
                  value: item.id,
                  label: item.name,
                  orgType: item.orgType,
                  disableAddressTo: item.disableAddressTo,
                },
          ),
        );
        setFetching(false);
      } catch (e) {
        setFetching(false);
      }
    },
  };
};
